import React, {useRef } from "react";
import Layout from "./layout";
import { useNavigate } from "react-router-dom";
import MetricCard from "../components/MetricCard";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "../components/DataTable";
import DateInput from "../components/DateInput";
import Button from "../components/Button";
import productsdata from "../assets/json/product.json";
import Bag from '../assets/svg/Bag.svg';
import PendingOrder from '../assets/svg/PendingOrder.svg';
import Bus from '../assets/svg/Bus.svg';
import Retry from '../assets/svg/Retry.svg';
import Cart from '../assets/svg/Cart.svg';

const Products = () => {
  const tableRef = useRef();

  const navigate = useNavigate();

  const columns = [
    { headname: "Image", type: "img", dbcol: "col1" },
    { headname: "Product name", type: "", dbcol: "col2" },
    { headname: "Price", type: "", dbcol: "col3" },
    { headname: "Category", type: "", dbcol: "col4" },
    { headname: "Tags", type: "tags", dbcol: "col5" },
    { headname: "Vendor", type: "", dbcol: "col6" },
    { headname: "Published on", type: "time", dbcol: "col7" },
  ];

  // ✅ Refresh page
  const handleRefresh = () => {
    window.location.reload(); // This will refresh the page
  };
  return (
    <Layout>
      <div className="d-flex justify-content-between">
        <div className="mt-3 d-flex align-items-center">
          <div className="d-flex gap-5 md-date "> 
            <DateInput label="" type="range" includeTime={false} />
          </div>

          {/* Refresh Button */}
          <div className=" mb-2 ps-3 md-refresh ">
            <i
              className="bi bi-arrow-repeat icon-refresh"
              onClick={handleRefresh}
            ></i>
          </div>
        </div>
        <div className="text-right gap-3 mb-3 mt-3 ie-btn d-flex">
          <Button buttonType="import" label="Import" />
          <Button buttonType="export" label="Export" />
          <div className="dropdown">
            <Button
              buttonType="add"
              onClick={() => navigate("/add-product")}
              label="Add New"
            />
          </div>
        </div>
      </div>

      <div className="card-container gap-4 flex-wrap fs-2 fs-md-1">
        <Row className="metrix-container">
          <Col xs={4} md>
            <MetricCard
              title="Total Orders" 
              operation="count"
              column="col1"
              tableRef={tableRef}
              icon={Bag}// You can change this to any Bootstrap icon name like "check-circle", "database", etc.
              tooltipText="This shows the count of live blogs" // Tooltip for additional context
            />
          </Col>
          <Col xs={4} md>
            <MetricCard
              title="Pending Orders"
              operation="count"
              column="col2"
              tableRef={tableRef}
              icon={PendingOrder} // You can change this to any Bootstrap icon name like "check-circle", "database", etc.
              tooltipText="This shows the count of Draft Blog" // Tooltip for additional context
            />
          </Col>
          <Col xs={4} md>
            <MetricCard
              title="Items ordered"
              operation="total"
              column="col4"
              tableRef={tableRef}
              icon={Bus} // You can change this to any Bootstrap icon name like "check-circle", "database", etc.
              tooltipText="This shows the total of Views" // Tooltip for additional context
            />
          </Col>
          <Col xs={4} md>
            <MetricCard
              title="Return"
              operation="count"
              column="col2"
              tableRef={tableRef}
              icon={Retry} // You can change this to any Bootstrap icon name like "check-circle", "database", etc.
              tooltipText="This shows the total of Users" // Tooltip for additional context
            />
          </Col>
          <Col xs={4} md>
            <MetricCard
              title="Total Revenue"
              operation="total"
              column="col3"
              tableRef={tableRef}
              icon={Cart} // You can change this to any Bootstrap icon name like "check-circle", "database", etc.
              tooltipText="This shows the New Comments" // Tooltip for additional context
            />
          </Col>
        </Row>
      </div>

      <DataTable
        id="table1"
        tableRef={tableRef}
        columns={columns}
        data={productsdata}
        defaultView="table"
        searchable={true}
        filterable={true}
        sortable={true}
        paginated={true}
      />
    </Layout>
  );
};

export default Products;
